import React from 'react';
import { motion } from 'framer-motion';
import { BadgeIcon } from './icons';
export const Guarantee: React.FC = () => {
  return <section className="py-20 px-6 sm:px-8 lg:px-12 max-w-4xl mx-auto border-t border-gold/30" data-id="element-50">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="bg-cream-light border-2 border-gold/30 rounded-2xl p-8 sm:p-12 text-center shadow-xl relative overflow-hidden" data-id="element-51">
        {/* Decorative background elements */}
        <div className="absolute top-0 left-0 w-32 h-32 bg-gold/5 rounded-br-full" data-id="element-52"></div>
        <div className="absolute bottom-0 right-0 w-32 h-32 bg-gold/5 rounded-tl-full" data-id="element-53"></div>

        <div className="relative z-10" data-id="element-54">
          <div className="flex justify-center mb-6" data-id="element-55">
            <div className="bg-white p-4 rounded-full shadow-md border border-gold/20" data-id="element-56">
              <BadgeIcon className="w-12 h-12 text-gold-dark" data-id="element-57" />
            </div>
          </div>

          <span className="text-xs font-bold tracking-[0.2em] text-forest uppercase block mb-4" data-id="element-58">
            The "Puppy Energy" Guarantee
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl text-forest-dark mb-6" data-id="element-59">
            60 Days. Zero Risk.
          </h2>

          <p className="text-lg text-charcoal/80 leading-relaxed max-w-2xl mx-auto" data-id="element-60">
            Try the protocol for 60 days. If you don't see a visible improvement
            in your dog's energy, coat, or mobility—or if you simply don't think
            it's worth 10x what you paid—email us for a 100% refund. No
            questions asked. We take all the risk.
          </p>
        </div>
      </motion.div>
    </section>;
};